// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"a74e28af","208":"aea3164c","256":"c7111360","420":"2bd3c9df","520":"7cd3e49b","592":"9785a45f","600":"2b753356","796":"4be37aaa","804":"af6dd2e5"}[chunkId] + ".chunk.js";
};